import { makeStyles } from '@material-ui/core';
import Appbar from 'components/appbar/Appbar';
import React from 'react';
import TableLoading from 'components/loading/TableLoading';
import { useApp } from 'App';

const styles = makeStyles(theme => ({
  container: {
    display: 'grid',
    gap: 30,
    gridTemplateColumns: '1.5fr 0.5fr',
    flex: 1,
    marginBottom: 20,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gridAutoRows: 'min-content',
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginBottom: 30,
  },
  headerFirstLine: {
    height: 32,
    width: '20%',
  },
  headerSecondLine: {
    height: 20,
    width: 200,
  },
  button: {
    height: 37,
  },
  total: {
    height: 100,
  },
  buttonsContent: {
    display: 'flex',
    gap: 10,
    flexDirection: 'column',
    backgroundColor: '#fff',
    padding: 20,
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      backgroundColor: 'unherit',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  moduleItem: {
    height: 100,
  },
}));
const BoardControlLoading: React.FC = () => {
  const classes = styles();
  const app = useApp();

  return (
    <>
      <Appbar title="Carregando mesa" />

      <div className={classes.header}>
        <div className={`animated-background ${classes.headerFirstLine}`} />
        <div className={`animated-background ${classes.headerSecondLine}`} />
      </div>

      <div className={classes.container}>
        {app.isMobile ? (
          <div className={classes.content}>
            <div className={`animated-background ${classes.moduleItem}`} />
            <div className={`animated-background ${classes.moduleItem}`} />
          </div>
        ) : (
          <TableLoading backgroundColor="inherit" />
        )}

        <div className={classes.buttonsContent}>
          <div className={`animated-background ${classes.button}`} />
          <div className={`animated-background ${classes.button}`} />
          <div className={`animated-background ${classes.button}`} />
          <div className={`animated-background ${classes.button}`} />
        </div>
      </div>
    </>
  );
};

export default BoardControlLoading;
